<template>
  <section id="tooltips">
    <div class="demo">
      <h5>Placements</h5>
      <div class="d-flex justify-content-around">
        <div class="text-center">
          <p><i data-toggle="tooltip" data-placement="left" data-original-title="Job" class="gel-icon-2x text-muted gel-icon-job"></i></p>
          <h6>Tooltip on left</h6>
        </div>
        <div class="text-center">
          <p><i class="gel-icon-2x text-muted gel-icon-employee" data-toggle="tooltip" data-placement="top" title="" data-original-title="Employee"></i></p>
          <h6>Tooltip on top</h6>
        </div>
        <div class="text-center">
          <p><i class="gel-icon-2x text-muted gel-icon-user" data-toggle="tooltip" data-placement="bottom" title="" data-original-title="Applicant"></i></p>
          <h6>Tooltip on bottom</h6>
        </div>
        <div class="text-center">
          <p><i class="gel-icon-2x text-muted gel-icon-support" data-toggle="tooltip" data-placement="right" title="" data-original-title="Live support"></i></p>
          <h6>Tooltip on right</h6>
        </div>
      </div>

      <hr class="sg-hr">
      <h5>Actionable</h5>
      <div class="text-center">
        <button class="btn btn-icon" aria-label="Print Position Details">
          <i class="gel-icon-2x text-muted gel-icon-print" aria-hidden="true" data-toggle="tooltip" data-placement="top" data-original-title="Print Position Description"></i>
        </button>
        <h6>Print</h6>
      </div>

      <hr class="sg-hr">   
      <h5>Descriptive</h5>
      <div class="text-center">
        <span role="tooltip" aria-label="Employee id" aria-describedby="tip1">
          <i data-toggle="tooltip" data-placement="top" data-original-title="Also known as system login user ID" class="gel-icon-employee text-muted" aria-hidden="true"></i>
          <span id="tip1" class="tooltip">Also known as system login user ID</span>
        </span>
        <h6>Employee ID</h6>
      </div>   
    </div>
    <section class="md" v-html="mdfile"></section>
  </section> 
</template>

<script>
import BSN from 'bootstrap.native/dist/bootstrap-native-v4'
import mdfile from "@/docs/components/tooltips.md";
export default {
  name: "tooltips",
  beforeCreate: function () {
    this.$emit("update-title", this.$root.yamlData.components.tooltips.name);
    this.$emit("update-tagline", this.$root.yamlData.components.tooltips.description);
  },
  mounted: function () {
    const icons = document.querySelectorAll('[data-toggle="tooltip"]')
    icons.forEach(icon => {
      new BSN.Tooltip(icon)
    })
  },
  data() {
    return {
      mdfile
    };
  }
};
</script>
